import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import AlertBar from '../alertBar/AlertBar';
import { usePutMutation } from '../hooks/useAuthenticatedMutation';
import parseFilters from '../parseFilters';
import useSnackbar from '../hooks/useSnackbar';

const EditSegmentAlertBar = ({
    selectedSegment,
    filters,
    open,
    onMount,
    onChangeSavedFilters,
    onChangeSelectedSegment,
    onChangeUnmodifiedSegment,
    onRevertSegmentChanges
}) => {
    const { showSnackbar } = useSnackbar();

    const segmentPutMutation = usePutMutation(`segments/${selectedSegment.id}`, 'segments');

    const handleUpdateSegment = () => {
        const stringifyFilterValues = () => {
            const parsedFilters = parseFilters(filters);
            return parsedFilters?.map(e => ({ ...e, value: e.value.toString() }));
        };

        const stringifiedFilters = stringifyFilterValues();

        const params = {
            ...selectedSegment,
            filters: stringifiedFilters?.length ? stringifiedFilters : null,
            groupId: selectedSegment?.groupId
        };

        segmentPutMutation.mutate(
            params,
            {
                onSuccess: (data) => {
                    onChangeSavedFilters(data.filters ?? null);
                    onChangeSelectedSegment(data);
                    onChangeUnmodifiedSegment(data);

                    showSnackbar('Segment updated', 'success');
                },
                onError: () => showSnackbar('Error: Segment not saved', 'error')
            }
        );
    };

    useEffect(() => {
        onMount();
    }, []);

    return (
        <AlertBar
            action={(
                <Button
                    onClick={handleUpdateSegment}
                    size="small"
                    loading={segmentPutMutation.isLoading}
                >
                    Save changes
                </Button>
            )}
            secondaryAction={(
                <Button
                    onClick={onRevertSegmentChanges}
                    size="small"
                    loading={segmentPutMutation.isLoading}
                    variant="outlined"
                >
                    Revert
                </Button>
            )}
            shown={open}
        >
            {segmentPutMutation.isLoading ? 'Updating...' : 'You have unsaved changes.'}
        </AlertBar>
    );
};

export default EditSegmentAlertBar;